import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { normalizePermission } from 'src/app/modules/permissions/models/permissions.model';
import { environment } from 'src/environment/environment';
import { AccessRoleResponse, ReplaceAccessRolePermissionsRequest } from '../models/access-roles.model';

@Injectable({ providedIn: 'root' })
export class AccessRolesApiService extends ApiService {
  getAccessRoles$(): Observable<AccessRoleResponse[]> {
    return this.get<AccessRoleResponse[]>('/AccessRoles').pipe(
      map((accessRoles) => accessRoles.map(normalizeAccessRole)),
    );
  }

  replaceAccessRolePermissions$(
    id: number,
    request: ReplaceAccessRolePermissionsRequest,
  ): Observable<AccessRoleResponse> {
    return this.put<AccessRoleResponse>(`/AccessRoles/${id}/permissions`, request).pipe(
      map(normalizeAccessRole),
    );
  }
}

function normalizeAccessRole(accessRole: AccessRoleResponse): AccessRoleResponse {
  return {
    ...accessRole,
    permissions: accessRole.permissions?.map((permission, index) =>
      normalizePermission(permission, index),
    ) || null,
  };
}

export const apiAccessRolesProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiAccessRoles.scopes.read],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiAccessRoles.scopes.write],
  },
];